'use client';
import { Toaster } from 'sonner';
import useThemeStore from '@/store/store.theme';

export default function ThemeToaster() {
  const dark = useThemeStore(s => s.dark);
  return <Toaster theme={dark ? 'dark' : 'light'} position="top-center" duration={3000} richColors closeButton
    toastOptions={{ classNames: {
      toast: '!rounded-xl !shadow-xl !w-[450px] max-w-[calc(100vw-24px)]',
      warning: '!bg-amber-50 !border-amber-200',
      title: '!font-semibold !text-lg !text-neutral-900',
      description: '!text-neutral-700 !text-lg',
      icon: '!w-7 !h-7 !text-neutral-500',
    } }} style={{ left: '50%', transform: 'translate(-63%, -50%)' }} />;
}
